import axios from "axios";

const axiosInstance = axios.create({
    baseURL: window.location.origin + "/sasuga-mobile-api-torizen/api",
    headers: {
        "Content-type": "application/json",
    }
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
    config => {
        // config.headers['Content-Type'] = 'application/json';
        config['credentials'] = 'include';
        return config
    },
    error => {
        Promise.reject(error)
    }
)

// axiosInstance.interceptors.response.use(response => {
//     console.log(response);
//     return response
// })

export default axiosInstance;